// removed by extract-text-webpack-plugin
module.exports = {"articleRow":"jmDGkRSg51ey0KvnGw_xR","article":"AAua9EVBhvWYnEV5y4fsB","count":"AhItpl4O6zbMZvdnzjWkf","buttonRemove":"_21yEnab-GzYie3soBh_q0D"};


//////////////////
// WEBPACK FOOTER
// ./app/dialogs/LocationEdit/style.scss
// module id = 961
// module chunks = 0